export default "__VITE_PUBLIC_ASSET__e14c471f__"